import { AxiosProgressEvent, AxiosRequestConfig } from 'axios'
import axios from 'axios'

import { type FileContent } from './types'

/**
 * Get a text file content by its signed URL.
 * @param signedUrl - The signed URL of the file.
 * @param options - Axios request config.
 * @returns The file content as a string.
 */
export const getFileContentBySignedUrl = async (
  signedUrl: string,
  onDownloadProgress?: (event: AxiosProgressEvent) => void,
  signal?: AbortSignal
): Promise<FileContent> => {
  const { data } = await axios.get<FileContent>(signedUrl, { signal, onDownloadProgress })
  return data
}

/**
 * Get a binary file content by its signed URL.
 * @param signedUrl - The signed URL of the file.
 * @param options - Axios request config.
 * @returns The file content as an ArrayBuffer.
 */
export const getBinaryFileContentBySignedUrl = async (
  signedUrl: string,
  options?: AxiosRequestConfig
): Promise<ArrayBuffer> => {
  const { data } = await axios.get<ArrayBuffer>(signedUrl, { responseType: 'arraybuffer', ...options })
  return data
}
